export default "/images/vendor/flag-icon-css/flags/4x3/do.svg?fe8ec4acc928625ae8966bbf68255166";